import React from 'react';
import { DefaultLazyResult, LazyComponentModel } from '../typings';

// offers
export const Offers = React.lazy(
  (): LazyComponentModel =>
    import('../pages/offers').then(
      (m): DefaultLazyResult => ({ default: m.Offers }),
    ),
);
export const OfferPage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/offer-page').then(
      (m): DefaultLazyResult => ({ default: m.OfferPage }),
    ),
);

// users
export const Settings = React.lazy(
  (): LazyComponentModel =>
    import('../pages/settings').then(
      (m): DefaultLazyResult => ({ default: m.Settings }),
    ),
);
export const UserCreatePage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/user-page').then(
      (m): DefaultLazyResult => ({ default: m.UserCreatePage }),
    ),
);
export const UserUpdatePage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/user-page').then(
      (m): DefaultLazyResult => ({ default: m.UserUpdatePage }),
    ),
);
export const UsersStatistic = React.lazy(
  (): LazyComponentModel =>
    import('../pages/users-statistic').then(
      (m): DefaultLazyResult => ({ default: m.UsersStatistic }),
    ),
);
export const CountryStatistics = React.lazy(
  (): LazyComponentModel =>
    import('../pages/country-statistics').then(
      (m): DefaultLazyResult => ({ default: m.CountryStatistics }),
    ),
);

// ltv
export const LtvPage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/ltv/LtvStatistic').then(
      (m): DefaultLazyResult => ({ default: m.LtvStatistic }),
    ),
);

// partners
export const Partners = React.lazy(
  (): LazyComponentModel =>
    import('../pages/partners').then(
      (m): DefaultLazyResult => ({ default: m.Partners }),
    ),
);
export const PartnerCreatePage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/partner-page').then(
      (m): DefaultLazyResult => ({ default: m.PartnerCreatePage }),
    ),
);
export const PartnerUpdatePage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/partner-page').then(
      (m): DefaultLazyResult => ({ default: m.PartnerUpdatePage }),
    ),
);

// rtb
export const RtbPage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/rtb').then((m): DefaultLazyResult => ({ default: m.Rtb })),
);
export const RtbCountriesPage = React.lazy(
  (): LazyComponentModel =>
    import('../pages/rtb-countries/RtbCountriesByDest').then(
      (m): DefaultLazyResult => ({ default: m.RtbCountriesByDest }),
    ),
);

// authentication
export const SignIn = React.lazy(
  (): LazyComponentModel =>
    import('../pages/sign-in').then(
      (m): DefaultLazyResult => ({ default: m.SignIn }),
    ),
);

// trends
export const Trends = React.lazy(
  (): LazyComponentModel =>
    import('../pages/trends/Trends').then(
      (m): DefaultLazyResult => ({ default: m.Trends }),
    ),
);

// hosts
export const Hosts = React.lazy(
  (): LazyComponentModel =>
    import('../pages/hosts/Hosts').then(
      (m): DefaultLazyResult => ({ default: m.Hosts }),
    ),
);
export const HostByCountries = React.lazy(
  (): LazyComponentModel =>
    import('../pages/host-by-countries/HostByCountries').then(
      (m): DefaultLazyResult => ({ default: m.HostByCountries }),
    ),
);
export const AdminPanel = React.lazy(
  (): LazyComponentModel =>
    import('../pages/admin-panel/AdminPanel').then(
      (m): DefaultLazyResult => ({ default: m.AdminPanel }),
    ),
);
